// extracted by mini-css-extract-plugin
module.exports = {"root":"BlockUI_root__1Ha0Y","blocker":"BlockUI_blocker__cyipK"};